export const BUTTON_PREVIEW_LABEL = 'Preview';
export const BUTTON_PREVIEW_TITLE = 'Preview the last saved version';
